'use client'

import {usePathname, useSearchParams} from 'next/navigation'
import {useRef} from 'react'
import {setQueriesForCanonical} from './set-queries-for-canonical'
import {getPathAlias, sessionStartQPKey} from '@app/analytics/helper'
import {interalNavigationQuery} from '../custom-links/game-link'

const SessionAnalyticsAttributesClient = () => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const query = searchParams ? Object.fromEntries(searchParams.entries()) : {}

  const isInternalNavRef = useRef(query['int-nav'] === '1' ? '1' : '0')
  const prevPathRef = useRef(pathname)

  if (prevPathRef.current !== pathname) {
    isInternalNavRef.current = '1'
    prevPathRef.current = pathname
  }

  const queries = {
    [sessionStartQPKey]: getPathAlias(pathname || ''),
    ...query,
    ...interalNavigationQuery,
    'int-nav': isInternalNavRef.current,
  }

  setQueriesForCanonical({queries})

  return null
}

export default SessionAnalyticsAttributesClient
